import moment from 'moment';

class Promo {
  constructor(promo) {
    var injector = angular.element(document).injector();
    this.$filter = injector.get('$filter');
    promo.effective = new Date(promo.effective);
    promo.expires = new Date(promo.expires);
    promo.modified = new Date(promo.modified);
    promo.customer_type = this.customerTypeMap(promo.customer_type);

    Object.assign(this, promo);
  }

  get singleUse() {
    return this.type === 'single_use_code';
  }

  get isEmail() {
    return this.type === 'email_domain';
  }

  get isMultiUse() {
    return this.type === 'multi_use_code';
  }

  get campaignLength() {
    return moment(this.expires).diff(this.effective, 'days');
  }

  get daysLeft() {
    const daysLeft = moment(this.expires).diff(moment(), 'days');
    return daysLeft > 0 ? daysLeft : 0;
  }

  get percentageOfUsesUsed() {
    if (!this.max_uses) {
      return;
    }

    return this.uses / this.max_uses;
  }

  get percentageOfCampaignPassed() {
    return Math.round((this.campaignLength - this.daysLeft) / this.campaignLength * 100);
  }

  get discountValue() {
    const discount = this.discount;

    switch (discount.type) {
      case 'percent':
        // return `${Math.round(discount.value * 100)}%`;
        return this.$filter('number')(discount.value * 100, 2) + "%";

      case 'dollar':
        // return `$${discount.value}`;
        return "£" + this.$filter('number')(discount.value, 2);
    }
  }

  get status() {
    if (this.ended) {
      return 'Expired';
    }

    if (this.started) {
      return 'Active';
    }

    return 'Pending';
  }

  get started() {
    return moment().isAfter(this.effective);
  }

  get ended() {
    return moment().isAfter(this.expires);
  }

  get hasCodes() {
    return this.type === 'single_use_code' || this.type === 'multi_use_code_group';
  }

  customerTypeMap(customerType) {
    let customerTypeMap = '';
    switch (customerType) {
      case 'ALL':
        customerTypeMap = 'All';
        break;
      case 'RETURNING':
        customerTypeMap = 'Returning';
        break;
      case 'NEW':
        customerTypeMap = 'New';
        break;
      default:
        customerTypeMap = customerType;
    }
    return customerTypeMap;
  }

  get isMultiSelect() {
    return !!this.service_codes;
  }
}

window.Promo = Promo;
